// extracted by mini-css-extract-plugin
module.exports = {"whatsapp_icon":"Style_whatsapp_icon__3Gatw"};